// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__MUSYg","label":"CategoryService_label__1ghHs","location":"CategoryService_location__3Rq_1"};